import type { ComponentProps } from "react";
import BaseActionButton from "./BaseActionButton";

type RetryButtonProps = Omit<
    ComponentProps<typeof BaseActionButton>,
    "iconType" | "testId" | "buttonType" | "label" | "loadingText"
> & {
    label?: string;
    loadingText?: string;
    buttonType?: "submit" | "button";
    variant?: ComponentProps<typeof BaseActionButton>["variant"];
};

const RetryButton = ({
    label = "Retry",
    loadingText = "Retrying...",
    buttonType = "button",
    variant = "outline",
    ...props
}: RetryButtonProps) => {
    return (
        <BaseActionButton
            label={label}
            loadingText={loadingText}
            iconType="retry"
            testId="retry-button"
            buttonType={buttonType}
            variant={variant}
            {...props}
        />
    );
};

export default RetryButton;
